export default __webpack_public_path__ + "d034ed2e82dec8a916a011b76d21b5ab.svg";